import { type RequestServiceOptions, utils } from '@atlaskit/util-service-support';

const DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';

export async function fetchAgg<Variables, Data>({
	graphQuery,
	variables,
	operationName,
	aggAbsoluteUrl: url = DEFAULT_GRAPHQL_ENDPOINT,
}: AggRequest<Variables>) {
	const options: RequestServiceOptions = {
		requestInit: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				operationName,
				query: graphQuery,
				variables,
			}),
		},
		queryParams: {
			...(operationName && { q: operationName }),
		},
	};
	return utils.requestService<AggResponse<Data>>({ url }, options);
}

type Maybe<T> = T | null;

export type AggError = {
	extensions?: Maybe<{
		classification?: Maybe<string>;
		errorSource?: Maybe<string>;
	}>;
	locations?: Maybe<
		Array<{
			column: number;
			line: number;
		}>
	>;
	message?: Maybe<string>;
};

export type AggRequest<Variables> = {
	aggAbsoluteUrl?: string;
	graphQuery: string;
	operationName?: string;
	variables: Variables;
};

export interface AggResponse<Data> {
	data?: Maybe<Data>;
	errors?: Maybe<AggError[]>;
	extensions?: Maybe<AggExtensions>;
}

export interface AggResults<Edge> {
	abTest?: Maybe<AggAbTest>;
	edges: Edge[];
	totalCount: number;
}

export interface AggEdge<Node> {
	node: Node;
}

export interface AggAbTest {
	abTestId?: Maybe<string>;
	controlId?: Maybe<string>;
	experimentId?: Maybe<string>;
}

export interface Latency {
	duration?: Maybe<number>;
	service?: Maybe<string>;
	started?: Maybe<string>;
	targetRegion?: Maybe<string>;
}

// Marking all optional for safety
export interface AggExtensions {
	gateway?: {
		crossRegion?: Maybe<boolean>;
		deprecatedFieldsUsed?: Maybe<any[]>;
		duration?: Maybe<number>;
		edgeCrossRegion?: Maybe<boolean>;
		httpCallLatency?: Maybe<Latency[]>;
		httpLatencyPerService?: Maybe<{
			search?: Maybe<number>;
			UppClient?: Maybe<number>;
		}>;
		interestingLatencie?: Maybe<Latency[]>;
		invokedServices?: Maybe<string[]>;
		micros_env?: Maybe<string>;
		request_id?: Maybe<string>;
		schema?: Maybe<{
			buildNumber?: Maybe<string>;
			buildTimestamp?: Maybe<string>;
			commitHash?: Maybe<string>;
			schemaHash?: Maybe<string>;
			schemaName?: Maybe<string>;
			snapshot?: Maybe<string>;
		}>;
	};
}
